<template>
  <span>
    <span @click="showModal">
      <slot></slot>
    </span>

    <b-modal v-model="modalView" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('PROFILE.EDIT_IMAGE.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEAM.EDIT.PROCESSING')}}</h5>
      </div>
      <div class="p-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">

          <div class="form-group row">
            <label class="col-form-label">{{ $t('PROFILE.EDIT_IMAGE.INPUT_IMAGE') }}</label>
            <b-form-file
              @change="changedImage"
              accept=".jpg, .png, .gif"
              v-model="addFormImage"
              :state="Boolean(addFormImage)"
              ></b-form-file>
          </div>

          <b-img class="profileImage" center :src="imageUrl" fluid></b-img>

        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideModal">{{ $t('CLOSE')}}</b-btn>
          <b-button
            variant="primary"
            class="btn-fill"
            v-if="Boolean(addFormImage)"
            @click="modalSubmit"
          >{{ $t('PROFILE.EDIT_IMAGE.SUBMIT')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  props: ["profile"],
  data() {
    return {
      modalView: false,
      modalLoading: false,
      addFormImage: "",
      imageUrl: "",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showModal() {
      this.modalView = true;
    },
    hideModal() {
      this.modalView = false;
      this.addEmail = "";
      this.addAdmin = 0;
      this.modalLoading = false;
    },
    changedImage(e)
    {
      let reader  = new FileReader();
      reader.addEventListener("load", function () {
        this.imageUrl = reader.result;
      }.bind(this), false);
      reader.readAsDataURL(e.target.files[0])
    },
    modalSubmit: function() {
      let self = this;
      this.modalLoading = true;
      let formData = new FormData();
      formData.append("ProfileImage", this.addFormImage);
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/profile/image/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          self.hideModal();
          self.$noty.info(self.$t("PROFILE.EDIT_IMAGESUCCESS.UPDATED_IMAGE"));
          self.$emit("updatedImage", response.data);
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  mounted: function() {
    if (this.profile.imageExtension == null) {
      this.imageUrl = "/img/default-avatar.png";
    } else {
      this.imageUrl = process.env.VUE_APP_BACKEND + "/profile/image/" + this.profile.id;
    }    
  }
};
</script>
<style>
</style>